import { makeAutoObservable, reaction } from 'mobx';

import { logger } from '@/lib/api/logger';

import { BetHistoryItem } from './BetHistoryItem';

export class Bet {
  constructor(props, store, bets) {
    makeAutoObservable(this);

    this.store = store;
    this.bets = bets;
    Object.assign(this, props);
    reaction(
      () => this.outcomePriceAndIsFrozen,
      ({ price, isFrozen, isBetBuilder = false }) => {
        if (isBetBuilder && this.store.root?.betBuilder) {
          try {
            this.store.root.betBuilder.updateBetBuilderCoefficient(this.eventId);
          } catch (error) {
            logger.error('Error updating BetBuilder coefficient', { error });
          }
          return;
        }

        if (price && price !== this.price) {
          this.updateProp('price', price);
        }
        if (!price) {
          this.updateProp('isFrozen', true);
          this.updateProp('price', price);
        } else if (isFrozen !== this.isFrozen) {
          this.updateProp('isFrozen', isFrozen);
        }
      },
    );
  }

  id = '';
  identity = 0;
  isFrozen = false;
  lid = '';
  marketName = '';
  name = '';
  price = 0;
  stake = null;
  startTime = 0;
  eventId = '';
  pidLid = '';
  tournamentId = '';
  eventName = '';
  slug = '';
  betHistory = [];
  reactionPrice = null;
  currentError = null;
  maxBet = null;
  isBetBuilderSupported = false;
  isBetBuilder = false;
  coefficient = 0;
  betBuilderOutcomes = [];
  pid = '';

  trackMarks = ['default'];

  get outcomePriceAndIsFrozen() {
    let price = 0;
    let isFrozen = this.isFrozen;
    let ids = [this.pidLid];
    let betBuilderOutcomes = [];
    let market = null;
    let outcome = null;

    if (this.isBetBuilder) {
      betBuilderOutcomes = this.betBuilderOutcomes ?? [];
      ids = betBuilderOutcomes.map((o) => o.pidLid);
    }

    for (const id of ids) {
      const m = this.store?.markets?.get(id);
      if (m) {
        market = m;
        break;
      }
    }

    if (market) {
      const outcomeIds = this.isBetBuilder ? betBuilderOutcomes.map((o) => o.outcomeId) : [this.id];
      outcome = market.outcomes.find(({ id }) => outcomeIds.includes(id));
      if (outcome) {
        price = outcome.price;
        isFrozen = outcome.isFrozen;
      }
    }
    return {
      isBetBuilder: this.isBetBuilder,
      isFrozen,
      price,
    };
  }

  updateProp = (name, value) => {
    if (this[name] !== value) {
      this[name] = value;
    }
    if (name === 'price') {
      this.addBetHistoryItem(value);
      this.bets.updateStorage(this.id, this.betHistory);
    }
  };

  addBetHistoryItem = (price) => {
    const betHistoryLastIndex = this.betHistory.length - 1;

    if (price && this.betHistory[betHistoryLastIndex].price !== price) {
      if (this.betHistory.length > 7) {
        this.betHistory.splice(1, this.betHistory.length - 7);
      }
      this.betHistory.push(
        new BetHistoryItem({
          price,
          timestamp: new Date().getTime(),
        }),
      );
    }
  };
}
